import React, { useEffect, useState } from 'react';
import { auth } from '../../firebase';
import { sendEmailVerification, sendPasswordResetEmail } from 'firebase/auth';
import ProfileImageUploader from '@/pages/profilepage/imageupload/ImageUpload'; // Import do modal para atualização da foto de perfil
import ChangePasswordModal from './updatePassword/updatePassword';
import CollabSelectionModal from './selectCollab/SelectCollab';
import { getTokenFromStorage } from '@/utils/getToken';
import { TokenPayload } from '@/components/navbar/tabs/MenuTabs';
import { jwtDecode } from 'jwt-decode';

const ProfilePage = () => {
  const [companyid, setCompanyid] = useState<number>();
  const [company, setCompany] = useState('');
  const [role, setRole] = useState('');
  const user = auth.currentUser;
  const [showModal, setShowModal] = useState(false); // Estado do modal
  const [showModalP, setShowModalP] = useState(false);
  const [showModalC, setShowModalC] = useState(false);
  const photoURL = user?.photoURL;
  const [colaboratorId, setColaboratorId] = useState<number>();
  const [colaborator, setColaborator] = useState('');
  const isVerified = user?.emailVerified;
  const [username] = useState(user?.displayName || '');
  const [email] = useState(user?.email || '');
  const handleOpenModal = () => setShowModal(true);
  const handleOpenModalP = () => setShowModalP(true);
  const handleCloseModalP = () => setShowModalP(false);
  const handleCloseModal = () => setShowModal(false);
  const handleOpenModalC = () => setShowModalC(true);
  const handleCloseModalC = () => setShowModalC(false);

  const API_URL = "/ws/api";
  // Fetch para buscar a empresa e o cargo do usuário
  useEffect(() => {

    const fetchTokenData = async () => {
      let token = getTokenFromStorage();
      let decodedToken: TokenPayload | undefined;

      if (token) {
        try {
          decodedToken = jwtDecode<TokenPayload>(token);
          if (decodedToken) {
            setCompanyid(decodedToken.companyId);
            if (decodedToken.colaboratorId) { setColaboratorId(decodedToken.colaboratorId); }
            setRole(decodedToken.roles[0])
          }
        } catch (error) {
          console.error('Erro ao decodificar token:', error);
        }
      }

      if (!decodedToken) {
        setTimeout(() => {
          token = getTokenFromStorage();
          if (token) {
            try {
              decodedToken = jwtDecode<TokenPayload>(token);
              if (decodedToken) {
                setCompanyid(decodedToken.companyId);
                if (decodedToken.colaboratorId) { setColaboratorId(decodedToken.colaboratorId); }
                setRole(decodedToken.roles[0])
              }
            } catch (error) {
              console.error('Erro ao tentar decodificar token novamente:', error);
            }
          }
        }, 3000);
      }
    };

    fetchTokenData();
  }, []);

  // Fetch para buscar os detalhes da empresa
  useEffect(() => {
    if (companyid !== null && companyid !== undefined) {
      const fetchCompanyData = async () => {
        try {
          const response = await fetch(
            `${API_URL}/api/companyId/${companyid}`
          );
          if (!response.ok) {
            throw new Error('Erro ao recuperar dados da empresa');
          }
          const data = await response.json();
          setCompany(data.fantasyName);
        } catch (error) {
          console.error('Erro ao buscar dados da empresa:', error);
        }
      };

      fetchCompanyData();
    }
  }, [companyid]);

  useEffect(() => {
    if (colaboratorId !== null && colaboratorId !== undefined) {
      const fetchColaboratorData = async () => {
        try {
          const response = await fetch(
            `${API_URL}/Collab/${colaboratorId}`, {
            headers: {
              'Authorization': `Bearer ${getTokenFromStorage()}`
            }
          }
          );
          if (!response.ok) {
            throw new Error('Erro ao recuperar dados do colaborador');
          }
          const data = await response.json();
          setColaborator(data.name);
        } catch (error) {
          console.error('Erro ao buscar dados do colaborador:', error);
        }
      };

      fetchColaboratorData();
    }
  }, [colaboratorId]);

  const handleSendVerification = async () => {
    try {
      if (user != null) {
        await sendEmailVerification(user);
        alert(`enviado email de verificação para ${email}`);
      }
    } catch (error) {
      console.error(`Erro ao enviar verificação para o email, ${error}`)
    }
  }

  const handleResetPassword = async () => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        alert(`Enviado email para Alteração de senha para ${email}`)
      })
      .catch((error) => {
        alert(`Ocorreu um erro ao enviar o email ${error.message}`);
      });
  }

  const handleAlert = () => {
    return (
      alert('Verifique o seu email para alterar a senha!')
    )
  }

  return (
    <div className="flex justify-center h-screen items-center bg-indigo-200">
      <div className="bg-gray-100 w-4/5 h-auto max-h-max p-6 rounded-2xl shadow-md flex flex-col">
        <h1 className="text-xl font-semibold mb-4">Perfil do Usuário</h1>

        <div className="flex flex-row">
          <div className="flex flex-col py-1 w-screen">
            <label className="mb-1 text-sm font-medium">Nome de usuário</label>
            <input
              type="text"
              className="p-2 border w-2/5 border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
              disabled
              value={username}
            />
            <div className="flex flex-col py-1">
              <label className="mb-1 text-sm font-medium">Endereço de email</label>
              <input
                type="email"
                className="p-2 border w-3/5 border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
                disabled
                value={email}
              />
              <div className="flex flex-col py-1">
                <label className="mb-1 text-sm font-medium">Empresa</label>
                <input
                  type="text"
                  className="p-2 border w-1/3 border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
                  value={company}
                  disabled
                />
                <div className="flex flex-col py-1">
                  <label className="mb-1 text-sm font-medium">Posição</label>
                  <input
                    type="text"
                    className="p-2 border w-1/3 border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
                    disabled
                    value={role}
                  />
                </div>
              </div>
              <div className="flex flex-col py-0">
                <label className="mb-1 text-sm font-medium">Colaborador</label>
                <input
                  type="text"
                  className="p-2 border w-1/3 border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
                  disabled
                  value={colaborator}
                />
              </div>
            </div>
          </div>
          <div dir="RTL" className="w-2/5 flex flex-col ml-6">
            {/* Foto de perfil */}
            <div className="flex justify-center items-center mb-4">
              {photoURL ? (
                <img
                  src={photoURL}
                  alt="Foto de perfil"
                  className="w-32 h-32 rounded-full object-cover"
                />
              ) : (
                <div className="w-32 h-32 rounded-full bg-gray-400 flex justify-center items-center">
                  <span className="text-white">Sem Foto</span>
                </div>
              )}
            </div>
            <div className="flex flex-col space-y-2 text-sm mt-4">
              <button
                className="text-blue-500 hover:underline"
                onClick={handleOpenModal} // Abre o modal
              >
                Mudar foto de perfil
              </button>
              <button
                onClick={handleSendVerification}
                className={`text-blue-500 hover:underline ${isVerified ? "cursor-not-allowed text-gray-500" : ""}`}
                disabled={isVerified}
              >
                {isVerified ? "Email já verificado" : "Verificar Email"}
              </button>
              {/* <button onClick={handleOpenModalC} className="text-blue-500 hover:underline">Alterar Colaborador</button> */}
              {(<button
                onClick={isVerified ? handleResetPassword : handleAlert}
                className={`text-blue-500 hover:underline`}
              >Alterar Senha
              </button>)}
            </div>
          </div>
        </div>
      </div>

      {/* Modais */}
      <CollabSelectionModal isOpen={showModalC} onClose={handleCloseModalC} />
      <ChangePasswordModal isOpen={showModalP} onClose={handleCloseModalP} />
      <ProfileImageUploader isOpen={showModal} onClose={handleCloseModal} />
    </div>
  );
};

export default ProfilePage;
